import { navigate } from './api';
import type { OneliveGnbMenuItem } from './oneliveGnbMenu';
import { ONELIVE_MOBILE_GNB_MENU } from './oneliveGnbMenu';

interface Props {
  items?: OneliveGnbMenuItem[];
  onNavigate?: () => void;
}

export default function OneliveMobileDrawerNav({
  items = ONELIVE_MOBILE_GNB_MENU,
  onNavigate,
}: Props) {
  return (
    <ul className="onelive-mobile-nav-list">
      {items.map((item) => (
        <li key={item.path}>
          <a
            href={item.path}
            className="onelive-mobile-nav-link"
            onClick={(e) => {
              e.preventDefault();
              navigate(item.path);
              onNavigate?.();
            }}
          >
            <img src={item.icon} alt="" className="onelive-mobile-nav-icon" />
            <span className="onelive-mobile-nav-label">{item.label}</span>
          </a>
        </li>
      ))}
    </ul>
  );
}
